<template>
    <div class='dynamic-content-container' :style='[styles, custom_styles.page]' :class="[{'page-builder-mode' : page_builder_mode, 'no-highlight': page_builder_mode}, classes.page]">
        <slot></slot>
    </div>
</template>

<script>
import format_custom_styles from "@/page_builder/builder/builder_tools/functions/format_custom_styles.js";

export default {
    components: {},
    props:['page', 'page_builder_mode'],
    mixins: [format_custom_styles],
    data(){
        return{
            styles:{},
            classes: []
        }
    },
    methods:{
        setStyles(){
            if(this.page.compiled_styles != null){
                this.styles = this.page.compiled_styles;
            }

            if(this.page.compiled_classes != null){
                this.classes = this.page.compiled_classes;
            }
        }
    },
    watch:{
        'page': {
            handler(){  
                this.setStyles();
                this.setCustomCssStyles(this.page.custom_styles); //From mixin
            },
            deep: true
        }
    },
    mounted(){
        if(this.$route.name != 'LivePreview'){
            this.setStyles();
            this.setCustomCssStyles(this.page.custom_styles); //From mixin
        }
    }
}
</script>

<style lang="scss" scoped>
.dynamic-content-container{
    display: flex;
    flex-direction: column;
}

.page-builder-mode{
    height: 100%;
    display: flex;
    flex-direction: column;
    gap: 30px;
    position: relative;
    // min-width: 600px;

    @container(width <= 768px) { //for mobile view on page builder
        flex-wrap: wrap;
    }
}

.no-highlight {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Old versions of Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently supported by Chrome, Edge, Opera and Firefox */
}
</style>